module.exports = __webpack_public_path__ + "media/audios/kid/lesson_5/audio_NiniNegativa-3f6e4e7c9af7a9ff1870d143f0e2dac4.m4a";